module.exports = __webpack_public_path__ + "static/media/pencil.a6a462cb.svg";